import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@wui/basics/typography';
import Icon from '@material-ui/core/Icon';
import { useGlobalContext, useDocumentTitle } from 'hooks';
import SectionDocuments from 'ui/sections/documents/SectionDocuments';

import PureButton from 'ui/components/pure-controls/PureButton';

const KBAWarning = ({ remainingAttempts, maxAttempts, onTryAgain }) => {
  useDocumentTitle('KBA Warning');
  const { history } = useGlobalContext();
  const redirect = () => history.push(SectionDocuments.reviewUrl);

  return (
    <Grid container spacing={1} className="kba__container">
      <Grid item xs={2}></Grid>
      <Grid item container xs={2} style={{ justifyContent: 'center' }}>
        <div className="kba__icon__warning" />
      </Grid>
      <Grid item container xs={6} className="kba__font">
        <h1 className="kba__title">Sorry, we are unable to continue with online notarization.</h1>
        <p className="kba__text">
          We are unable to verify your identity. The information provided does not match the
          available authentication information.
        </p>
        <p className="kba__text">
          You can try entering your information again or return back to your documents at anytime to
          download and notarize in person.
        </p>
        {remainingAttempts > 0 && (
          <Box className="kba__warning__box">
            <Icon className="kba__warning">warning</Icon>
            <Typography className="kba__text">
              After {maxAttempts} failed attempts, further verification attempts will be locked for
              48 hours.
              <br />
              <strong>
                {remainingAttempts} out of {maxAttempts} attempts remain.
              </strong>
            </Typography>
          </Box>
        )}
        <Grid item container style={{ marginTop: '56px' }}>
          <Grid item>
            <PureButton onClick={onTryAgain} className="button--primary kba__button">
              Try again
            </PureButton>
            <PureButton onClick={redirect} className="button--secondary kba__button">
              Go back to my documents
            </PureButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={1}></Grid>
    </Grid>
  );
};

KBAWarning.propTypes = {
  remainingAttempts: PropTypes.number.isRequired,
  maxAttempts: PropTypes.number.isRequired,
  onTryAgain: PropTypes.func.isRequired,
};

export default observer(KBAWarning);
